import {isMobile} from '../util/breakpoints';
import copyToClipboard from '../util/clipboard';
import openNativeShare from '../util/nativeShare';
import {scrollToTarget} from '../util/smoothScroll';
import {convertToKebabCase} from '../util/stringUtils';
import {initImageGallery} from '../components/imageGallery';
import {initCarousel} from '../components/carousel';

const supportedJumpHeaders = [
  'Who we are',
  'About the Role',
  "What you'll do", /* eslint-disable-line */
  'Qualifications',
  'Perks and Benefits',
];

function cleanupJobDescription() {
  const contentContainerEl = document.querySelector('[data-careers-details] [data-description-container]');

  if (!contentContainerEl) {
    return;
  }

  const galleryTemplate = document.querySelector('template#city-gallery');
  const headingEls = contentContainerEl.querySelectorAll('p');

  headingEls.forEach((el) => {
    if (!el.querySelector('strong')) {
      return;
    }

    const headerContentEl = el.querySelector('strong');
    const headerContent = headerContentEl.innerText;
    const headingEl = document.createElement('h2');

    headingEl.innerText = headerContent;
    headingEl.classList.add('careers-details__desc-section-title');


    if (supportedJumpHeaders.filter((supportedHeader) => headerContent.toLowerCase().includes(supportedHeader.toLowerCase())).length !== 0) {
      headingEl.setAttribute('data-content-jump-link', true);
      headingEl.setAttribute('id', convertToKebabCase(headerContent));
    }

    headerContentEl.remove();

    const remainingContentEl = el.cloneNode(true);

    el.replaceWith(headingEl);
    headingEl.insertAdjacentElement('afterend', remainingContentEl);

    // setup gallery block if applicable
    if (headerContent.toLowerCase() === supportedJumpHeaders[1].toLowerCase() && galleryTemplate) {
      headingEl.parentNode.insertBefore(galleryTemplate.content.cloneNode(true), headingEl);
      initCarousel();
      initImageGallery();
    }
  });
}

function jumpLinkTextTransformer(headerText) {
  if (headerText.toLowerCase().includes('successful')) {
    return 'Requirements';
  }

  return headerText;
}

function setupJobDescriptionJumpLinks() {
  const contentContainerEl = document.querySelector('[data-careers-details] [data-description-container]');

  if (!contentContainerEl) {
    return;
  }

  const jumpLinkTargets = contentContainerEl.querySelectorAll('[data-content-jump-link]');
  let jumpLinkContainer = document.querySelector('[data-careers-details] [data-aside-nav-list]');

  jumpLinkTargets.forEach(lt => {
    const linkEl = document.createElement('a');
    let linkItemEl = document.createElement('li');

    linkEl.innerText = jumpLinkTextTransformer(lt.innerText);
    linkEl.href = '#' + lt.getAttribute('id');
    linkItemEl.classList.add('careers-details__aside-jump-link');

    linkItemEl.append(linkEl);
    jumpLinkContainer.append(linkItemEl);

    linkEl.addEventListener('click', () => {
      scrollToTarget(lt, document.querySelector('body'));
    });
  });
}

function bindShareButton() {
  const shareButton = document.querySelector('[data-job-share-trigger]');

  if (!shareButton) {
    return;
  }

  shareButton.addEventListener('click', () => {
    let shareUrl = document.location.href;

    if (isMobile()) {
      let shareData = {
        url: shareUrl
      };

      openNativeShare(shareData)
        .catch(e => {
          console.error(e);

          // fallback to copying the article link to the clipboard
          copyToClipboard(shareUrl);
          shareButton.querySelector('span').innerText = 'COPIED!';
          setTimeout(() => shareButton.querySelector('span').innerText = 'SHARE', 2000);
        });

      return;
    } else {
      copyToClipboard(shareUrl);
      shareButton.querySelector('span').innerText = 'COPIED LINK!';
      setTimeout(() => shareButton.querySelector('span').innerText = 'SHARE', 2000);
    }
  });
}

function trackGreenhouseSource() {
  if (!('URLSearchParams' in window)) {
    return;
  }

  const srcInput = document.getElementById('gh-src');
  const querySource = new URLSearchParams(window.location.search);

  if (srcInput && querySource.has('gh_src')) {
    srcInput.value = querySource.get('gh_src');
  }
}

export default {
  init() {
    bindShareButton();
    cleanupJobDescription();
    setupJobDescriptionJumpLinks();
    trackGreenhouseSource();
  }
};
